import * as React from "react";
import { Chart, ChartLegend, ChartSeries, ChartSeriesItem, ChartSeriesLabels } from "@progress/kendo-react-charts";
const AssetAllocation = ({
  assetDetails
}) => {
  console.log('assetDetails1', assetDetails)

  const donutRor = assetDetails.map((item) => ({
    category: item.AlternateName,
    value: item.ROR,
  }));
  return <Chart style={{
    height: "100%"
  }}>
      <ChartSeries>
        <ChartSeriesItem type="donut" data={donutRor} field="value"   categoryField="category" >
        <ChartSeriesLabels color="#fff" background="none" content={donutRor} field="category" />
        </ChartSeriesItem>
      </ChartSeries>
      <ChartLegend position={"bottom"} visible={true} />
    </Chart>;
};
export default AssetAllocation;